import React, { createContext, useMemo, useState } from 'react';

interface PurchaseContextValue {
  vehicleId: number | null;
  setVehicleId: (id: number | null) => void;
}

const PurchaseContext = createContext<PurchaseContextValue>({
  vehicleId: null,
  setVehicleId: () => {
    void 0;
  }
});

const PurchaseProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [vehicleId, setVehicleId] = useState<number | null>(null);
  const value = useMemo(() => ({ vehicleId, setVehicleId }), [vehicleId]);

  return <PurchaseContext.Provider value={value}>{children}</PurchaseContext.Provider>;
};

export default PurchaseContext;
export { PurchaseProvider };
